<template>
  <div class="mx-auto max-w-2xl">
    <form
      ref="form"
      action="/member_past_presents"
      accept-charset="UTF-8"
      method="post"
    >
      <div class="stack-mt-12">
        <member-form-field
          v-for="field in mainFormFields"
          :key="field.id"
          :field="field"
          v-model="field.value"
        >
          forcerefresh
        </member-form-field>
      </div>

      <!-- Documents Follow-up Section (always visible) -->
      <document-follow-up-section-intro />
      <div class="mt-6">
        <member-form-field
          v-if="form.required_documents"
          :field="form.required_documents"
          v-model="form.required_documents.value"
        >
          forcerefresh
        </member-form-field>
      </div>

      <!-- Message Preview -->
      <div v-if="messagePreview" class="mt-6 p-6 bg-blue-50 border border-blue-200 rounded-lg">
        <h3 class="text-sm font-semibold text-blue-900 mb-2">📱 Message Preview - What Cara will send:</h3>
        <div class="text-sm text-gray-700 whitespace-pre-line font-mono bg-white p-4 rounded border border-blue-100">{{ messagePreview }}</div>
      </div>

      <case-note-section-intro />

      <div v-if="additional" class="stack-mt-12 mt-6">
        <member-form-field
          v-for="field in additional"
          :key="field.id"
          :field="field"
          v-model="field.value"
        >
          forcerefresh
        </member-form-field>
      </div>

      <div class="mt-8 pt-5">
        <member-form-errors
          v-if="formHasErrors"
          :error-fields="errorFields"
        ></member-form-errors>

        <div class="flex justify-end">
          <button
            @click.prevent="submit"
            v-if="memberSpecified"
            type="submit"
            class="button button-primary inline-block px-16 py-3"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MemberFormShared from "./MemberFormShared"
import MemberPastPresentConditions from "./MemberPastPresentConditions"
import DocumentFollowUpSectionIntro from "./DocumentFollowUpSectionIntro.vue"
export default {
  components: {
    DocumentFollowUpSectionIntro,
  },
  mixins: [MemberFormShared, MemberPastPresentConditions],
  props: {
    member: { type: Object, default: null },
    currentUser: { type: Object, default: null },
  },
  data() {
    return {
      tableName: "member_past_present",
      shouldConfirmReload: true,
      documentLabels: {
        universal_credit: "Universal Credit statements (3 months - but if self-employed, 6 months)",
        payslips_weekly: "Payslips (last 5-6 weeks)",
        payslips_monthly: "Payslips (last 3 months)",
        bank_statements: "Bank statements (last 3 months)",
        child_benefit: "Child Benefit documents",
        right_to_work_rent: "Right to Work/Rent documents (passport, share code, BRP)",
        dla_pip: "DLA/PIP documents (award letters or payment evidence)",
        other_benefits: "Other proof of benefits (award letters, benefit statements)",
      },
    }
  },
  computed: {
    mainFormFields() {
      // Return all form fields except required_documents (which is rendered separately)
      if (!this.form || typeof this.form !== 'object') {
        return {}
      }
      const { required_documents, ...mainFields } = this.form
      return mainFields
    },
    messagePreview() {
      const documents = this.form?.required_documents?.value

      if (!documents || documents.length === 0) {
        return null
      }

      const memberFirstName = this.member?.first_name || "[Member's name]"
      const caseworkerName = this.currentUser?.first_name || "[Caseworker name]"
      const caseworkerEmail = this.currentUser?.email || "[caseworker email]"

      const documentList = documents
        .map((doc) => `• ${this.documentLabels[doc] || doc}`)
        .join("\n")

      return `Hi ${memberFirstName},

Lovely speaking with you today.

Could you please send me the following documents:

${documentList}

You can send these to me by replying here, or email them to ${caseworkerEmail}.

Thanks!

Best wishes,
${caseworkerName} from Beam`
    },
  },
  watch: {
    "form.member_id.value": {
      handler() {
        if (
          this.form?.member_id?.value &&
          !location.href.includes(`member_id=${this.form.member_id.value}`)
        ) {
          this.shouldConfirmReload = false
          location.href = `/member_past_presents/new?member_id=${this.form.member_id.value}`
        }
      },
      immediate: true,
    },
  },
  methods: {
    // Overriding this method so that when member ID changes we can stop it from preventing unload
    handleUnload(e) {
      if (this.shouldConfirmReload) {
        return MemberFormShared.methods.handleUnload.call(this, e)
      }
    },
  },
}
</script>
